import { render, staticRenderFns } from "./box-receive-log.vue?vue&type=template&id=1fd2640f&scoped=true&"
import script from "./box-receive-log.vue?vue&type=script&lang=js&"
export * from "./box-receive-log.vue?vue&type=script&lang=js&"
import style0 from "./box-receive-log.vue?vue&type=style&index=0&id=1fd2640f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd2640f",
  null
  
)

export default component.exports